import request from '@/utils/request';

import type { FetchResp } from './reservation.data';

const RESERVATION_API = 'reservations';
export async function fetch(params?: any): Promise<FetchResp> {
  return request.get(`/${RESERVATION_API}`, {
    params,
  });
}

export async function updateReservationStatus(id: string, params: any) {
  return request.patch(`/${RESERVATION_API}/${id}`, {
    data: params,
  });
}

export async function countUnread(params?: any): Promise<FetchResp> {
  return request.get(`/${RESERVATION_API}/countUnread`, {
    params,
  });
}
